var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElDialog',{attrs:{"visible":_vm.value,"title":_vm.$t('ADVERTISEMENT.NEW_CAMPAIGN_SEARCH_ADS'),"width":"35%"},on:{"close":_vm.closeAndReset}},[_c('AddSearchCampaignGeneral',{attrs:{"reset-controller":_vm.resetController,"apps":_vm.apps,"campaigns":_vm.campaigns},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }